import React, { useRef, useState } from "react";
import SkeletonTable from "../Skeleton/SkeletonTable";
import { handleStatus } from "../../helperFunctions/helpers";
import { buildName, buildNameWithId } from "helper/tools";
import BadgeStatus from "../Asociados/BadgeStatus";

export default function ClientesTable({
  items,
  openItem,
  handleSortChange,
  isLoading = false,
}) {
  const theadRef = useRef();

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  return (
    <table
      className="table table-borderless datable sortable table-hover"
      style={{ tableLayout: "fixed" }}
    >
      <thead className="table-light" style={{ textAlign: "center" }}>
        <tr ref={theadRef}>
          <th
            scope="col"
            data-column="id"
            style={{ width: "80px" }}
            onClick={(event) => handleSort(event)}
          >
            Id
          </th>

          <th
            scope="col"
            data-column="nombre"
            onClick={(event) => handleSort(event)}
          >
            Nombre
          </th>
          <th
            scope="col"
            data-column="asociadosId"
            onClick={(event) => handleSort(event)}
          >
            Asociado
          </th>
          <th
            scope="col"
            data-column="nickname"
            style={{ width: "100px" }}
            onClick={(event) => handleSort(event)}
          >
            Alias
          </th>
          <th
            scope="col"
            data-column="correo"
            style={{ width: "100px" }}
            onClick={(event) => handleSort(event)}
          >
            Email
          </th>
          <th
            scope="col"
            data-column="celular"
            style={{ width: "110px" }}
            onClick={(event) => handleSort(event)}
          >
            Celular
          </th>
          <th
            scope="col"
            data-column="activo"
            style={{ width: "100px" }}
            onClick={(event) => handleSort(event)}
          >
            Estatus
          </th>
        </tr>
      </thead>
      <tbody>
        {isLoading && <SkeletonTable columnCount={7} rowCount={6} />}

        {!isLoading &&
          items.length > 0 &&
          items.map((item) => {
            const nombre = buildName(item, true);
            /*  const nombreAsociado = buildNameWithId(
              item.asociado,
              item.asociado.numAsociado
            );*/

            let nombresAsociados = [];
            if (item.asociados != null && item.asociados.length > 0) {
              nombresAsociados = item.asociados.map((asociado) => {
                const nombreAsociado = buildNameWithId(
                  asociado,
                  asociado.numAsociado,
                );
                return nombreAsociado;
              });
            }

            return (
              <tr key={item.id}>
                <th
                  scope="row"
                  style={{
                    verticalAlign: "middle",
                    justifyItems: "center",
                    textAlign: "center",
                  }}
                >
                  <a href="#" onClick={(e) => openItem(item)}>
                    {item.numCliente ? item.numCliente : "--"}
                  </a>
                </th>
                <td>
                  <a
                    href="#"
                    className="text-primary"
                    onClick={(e) => openItem(item)}
                  >
                    {nombre}
                  </a>
                </td>
                <td
                  className="d-flex"
                  style={{ gap: "6px", flexDirection: "column" }}
                >
                  {nombresAsociados.map((e) => {
                    return <div key={e.id}>{e}</div>;
                  })}
                </td>
                <td>{item.nickname ?? ""}</td>
                <td>{item.correo ?? ""}</td>
                <td>{item.celular ?? ""}</td>

                <BadgeStatus item={item} />
              </tr>
            );
          })}
      </tbody>
    </table>
  );
}
